import textServices from 'services/text-services'
import { dlTrackEvent } from 'components/dataLayer/dataLayer'
import { PIT_STOPS_ANCHOR_ID } from '../constants'
import PitStopModules from './PitStopModules'
import F1Picture from './F1Picture'

interface PitStopsSectionProps {
  isLogged: boolean
  onCtaClick: () => void
}

// Pit Stops section (visitor: Figma 5595:12188 / logged: 5409:3581).
// Visitors get the nudge copy + participation CTA; logged users get the
// modules container (the four weekly modules land here in Phase 2).
const PitStopsSection = ({ isLogged, onCtaClick }: PitStopsSectionProps) => {
  return (
    <section id={PIT_STOPS_ANCHOR_ID} className="pitstops__final">
      <F1Picture
        name="background-barras_diagonal"
        pictureClassName="pitstops__final-bg"
        className="pitstops__final-bg-media"
      />
      <h2 className="pitstops__final-title">
        {textServices.findByText('pitstops/final/title', 'Pit Stops')}
      </h2>
      <p className="pitstops__final-text">
        {textServices.findByText(
          'pitstops/final/text',
          'Completa todos los retos semanales para competir por el premio final. Cada semana se desbloquea un nuevo Pit Stop y podrás participar de los primeros 3 hasta que se active el último.'
        )}
      </p>
      {isLogged ? (
        <PitStopModules />
      ) : (
        <>
          <p className="pitstops__final-nudge">
            {textServices.findByText(
              'pitstops/final/nudge',
              '¿Aún no estás participando? No dejes pasar la oportunidad.'
            )}
          </p>
          <button
            type="button"
            className="home-v3__button pitstops__cta"
            onClick={() => {
              dlTrackEvent('user_interaction', {
                action: 'click',
                element: 'pit stops :: quiero participar',
                section: 'pitstops'
              })
              onCtaClick()
            }}
          >
            {textServices.findByText('pitstops/final/cta', '¡Quiero participar!')}
          </button>
        </>
      )}
    </section>
  )
}

export default PitStopsSection
